/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorBipInfoModel } from '../../models/behavior-bip-info-model';

export interface GetNewBehaviorBIPInfos$Params {
  patientID?: number;
}

export function GetNewBehaviorBIPInfos(http: HttpClient, rootUrl: string, params?: GetNewBehaviorBIPInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorBipInfoModel>>> {
  const rb = new RequestBuilder(rootUrl, GetNewBehaviorBIPInfos.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BehaviorBipInfoModel>>;
    })
  );
}

GetNewBehaviorBIPInfos.PATH = '/api/Staff/GetNewBehaviorBIPInfos';
